import { GetPublicItineraryResponse } from '@orbit/api-types'
import { queryKeys } from '@lib/queryKeys'
import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { config } from '../config'

const publicApi = axios.create({
	baseURL: `${config.apiUrl}/v1`,
	headers: { 'Content-Type': 'application/json' },
	timeout: 15000,
})

export const usePublicItinerary = (tripCode: string | undefined) => {
	return useQuery<GetPublicItineraryResponse>({
		queryKey: queryKeys.publicItinerary(tripCode),
		queryFn: async () => {
			if (!tripCode) throw new Error('Trip code is required')
			const response = await publicApi.get<GetPublicItineraryResponse>(
				`/trips/${tripCode}/public-itinerary`,
			)
			return response.data
		},
		enabled: !!tripCode,
		retry: 1,
	})
}
